import {
  Box,
  Flex,
  Text,
  Spinner,
  useBreakpointValue
} from "@chakra-ui/react";
import { useCallback, useEffect, useState } from "react";
import { Column } from "react-table";

import { Header } from "../../../components/Header";
import { Sidebar } from "../../../components/Sidebar";
import ContentBase from "../../../components/ContentBase";
import MainBase from "../../../components/MainBase";
import MainActions from "../../../components/MainActions";
import { MainTable } from "../../../components/MainTable";
import { RemoveAccent } from "../../../utils/RemoveAccent";
import { FQA, useFQAs } from "../../../services/hooks/useFQA";

export function FQAsList() {
  const [searchField, setSearchField] = useState('');
  const [allFQAs, setAllFQAs] = useState<FQA[]>([]);

  const { data, isLoading, isFetching, error } = useFQAs()

  const fileName = `Lista-de-fqas-${Date.now()}.csv`;
  const csvHeaders = [
    {
      label: 'Título',
      key: 'title'
    },
    {
      label: 'Descrição',
      key: 'description'
    },
    {
      label: 'YouTube Video ID',
      key: 'embed_id'
    },
  ]

  useEffect(() => {
    if (data) {
      setAllFQAs(data)
    }
  }, [data])

  const handleChangeSearch = useCallback((fqa) => {
    setSearchField(fqa.target.value)
  }, [])

  const handleSearch = useCallback(() => {
    if (data) {
      if (searchField) {
        const searchFieldWithoutAccent = RemoveAccent(searchField.toLowerCase())
        const fqasFiltered = data.filter(
          fqa => RemoveAccent(fqa.title.toLowerCase()).match(searchFieldWithoutAccent)
        )

        setAllFQAs(fqasFiltered)

        return
      }

      setAllFQAs(data)
    }
  }, [searchField, data])

  const handleOnPressEnter = useCallback((event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  }, [handleSearch])

  const columns: Column<FQA>[] = [
    {
      Header: "Título",
      accessor: "title",
      //  @ts-ignore TYPE NEEDS FIXING
      isSortable: true,
    },
  ];

  const fqaActions = [
    {
      type: 'edit',
      url: '/fqas/update/<id>',
    }
  ]

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  })

  return (
    <Flex direction="column" h="100vh">
      { !isWideVersion && <Header /> }

      <ContentBase>
        <Sidebar />

        <MainBase
          mainTitle="Perguntas frequentes"
          isLoading={isLoading}
          isFetching={isFetching}
        >
          <MainActions
            handleChangeSearch={handleChangeSearch}
            handleOnPressEnter={handleOnPressEnter}
            handleSearch={handleSearch}
            searchPlaceHolder="Digite o título que deseja procurar..."
            createLink="/fqas/create"
            csvDownload={{
              csvData: allFQAs,
              csvHeaders: csvHeaders,
              csvFileName: fileName,
            }}
          />

          <Box
            w="100%"
            h={["", null, null, "80vh"]}
          >
            { isLoading ? (
              <Flex justify="center">
                <Spinner color="blue.900" size="xl" />
              </Flex>
            ) : error ? (
              <Flex direction="column">
                <Text fontSize="lg" color="blue.900">Oops...ocorreu uma falha ao obter as perguntas frenquentes :(</Text>
                <Text fontSize="lg" color="blue.900">Tente novamente ;)</Text>
              </Flex>
            ) : (
              <Flex
                w="100%"
                h="100%"
                direction="column"
                justifyContent="space-between"
              >
                <MainTable
                  columns={columns}
                  data={allFQAs}
                  actions={fqaActions}
                />
              </Flex>
            )}
          </Box>
        </MainBase>
      </ContentBase>
    </Flex>
  );
}
